/* unplugin-vue-components disabled */import { render } from "./SongComment.vue?vue&type=template&id=2fea51b8&scoped=true"
import script from "./SongComment.vue?vue&type=script&lang=js"
export * from "./SongComment.vue?vue&type=script&lang=js"

import "./SongComment.vue?vue&type=style&index=0&id=2fea51b8&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea51b8"]])

export default __exports__